export default __webpack_public_path__ + "static/image-b-6584b3ba63bc4335ebd656dd5d694c62.png";